// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20106-会员人脸信息上传 POST /app/v1/member/faceImgUpload */
export async function uploadFaceImg(
  body: API.FaceImgUploadReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/member/faceImgUpload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20107-根据身份证号获取个人信息 GET /app/v1/member/idCardInfo/${param0} */
export async function getIdCardInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getIdCardInfoParams,
  options?: { [key: string]: any }
) {
  const { idCard: param0, ...queryParams } = params;
  return request<API.YmResultVOIdCardInfoRespVO>(
    `/app/v1/member/idCardInfo/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20103-会员信息查询 GET /app/v1/member/info */
export async function getMemberInfo(options?: { [key: string]: any }) {
  return request<API.YmResultVOMemberInfoVo>("/app/v1/member/info", {
    method: "GET",
    ...(options || {}),
  });
}

/** 20101-会员注册(code换取token) POST /app/v1/member/loginByCode */
export async function loginByCode(
  body: API.LoginByCodeReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOMemberLoginResVO>("/app/v1/member/loginByCode", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20102-会员手机登录 POST /app/v1/member/loginByPhone */
export async function loginByPhone(
  body: API.LoginByPhoneReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOMemberLoginResVO>(
    "/app/v1/member/loginByPhone",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20104-会员信息修改 POST /app/v1/member/update */
export async function updateMemberInfo(
  body: API.UpdateMemberInfoReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/member/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20105-维护手机号 POST /app/v1/member/updatePhone */
export async function updatePhone(
  body: API.UpdatePhoneReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/member/updatePhone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
